export default {
  headerContent: {
    title: 'Quick Sigorta Alacak Sigortası Fiyatları',
    slogan: "Alacak Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'Alacak Sigortası TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Quick Sigorta Alacak Sigortası',
    description: {
      title: 'Quick Sigorta Alacak Sigortası Nedir? ',
      content: [
        'Alacak sigortası, orta ve küçük ölçekli işletmelerin vadeli satışlarından doğan alacak risklerini güvence altına almak için Hazine ve Maliye Bakanlığı tarafından oluşturulmuş sigorta ürünüdür.',
        "Devlet Destekli Alacak Sigortası KOBİ'lerin alacaklarını garanti altına almaktadır.",
        'Alacak sigortası yapan firmalar arasında yer alan Quick Sigorta’nın fiyatlarını sitemizden teklif alarak kolayca değerlendirebilirsiniz.'
      ]
    },
    subContent: {
      title: 'Quick Sigorta Alacak Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph: 'Alacak sigortası yaptırmak isteyen işletmeler;',
          subList: [
            'En az 2 yıldır faaliyetini sürdürüyor olması,',
            'Vergi ve SGK borcunun bulunmaması,',
            'Yıllık Cirosu 25 Milyon TL’den az olması,',
            'Olağan Dışı Risk Yönetim Merkezi tarafından belirlenen risk değerlendirme kriterlerini karşılaması gerekmektedir.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Alacak Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Alacak Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Alacak Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Alacak Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Alacak Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Quick Sigorta Alacak Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
